/**
 * This takes a number of seconds and converts it to a HH:MM:SS format
 * This removes the hours if it is 0
 * This will pad the minutes and seconds with a 0 if they are less than 10 and removes the milliseconds
 * @param inputSeconds
 */
export function toHHMMSS(inputSeconds: number): string {
  const hours = Math.floor(inputSeconds / 3600);
  const minutes = Math.floor((inputSeconds % 3600) / 60);
  const seconds = inputSeconds % 60;

  const formatTime = (num: number) => String(num.toFixed(0));

  if (hours > 0) {
    return `${hours}:${formatTime(minutes).padStart(2, '0')}:${formatTime(
      seconds
    ).padStart(2, '0')}`;
  } else {
    return `${formatTime(minutes)}:${formatTime(seconds).padStart(2, '0')}`;
  }
}
